export default __webpack_public_path__ + "db229364d26bb5d813e594b553e6f337.png";